import { P2GBox, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Banners from '~/apps/smartsend/components/content/Banners';
import Notifications from '~/apps/smartsend/components/notifications/Notifications';
import Edit from '~/apps/smartsend/components/smartsend/edit/Edit';
import WalkthroughPrompt from '~/apps/smartsend/components/smartsend/onboarding/WalkthroughPrompt';
import Tasks from '~/apps/smartsend/components/task/Tasks';
import { ConcernsContextProvider } from '~/apps/smartsend/lib/context/ConcernsContext';
import { DownloadContextProvider } from '~/apps/smartsend/lib/context/DownloadContext';
import { SmartSendContextProvider } from '~/apps/smartsend/lib/context/SmartSendContext';
import EventEmitterRC from '~/apps/smartsend/lib/em/EventEmitterRC';
import { SmartSendTasks } from './smartsend-tasks';
import { useAuth } from 'react-oidc-context';
import { P2GImageMessage } from '~/components/imagemessage';
import { Navigation } from '~/components/nav/nav';
import { NavigationContextProvider } from '~/components/nav/nav-context';
import { ProfileContextProvider } from '~/apps/smartsend/lib/context/ProfileContext';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { isAuthenticated } = useAuth();
  return (
    <Suspense fallback={<></>}>
      {isAuthenticated ? (
        <NavigationContextProvider>
          <EventEmitterRC>
            <DownloadContextProvider>
              <SmartSendContextProvider>
                <ProfileContextProvider>
                  <ConcernsContextProvider>
                    <Banners tab={''} isXs={isXs} />
                    <P2GBox sx={(t) => ({ backgroundColor: t.palette.grey?.A100 })}>
                      <Navigation isXs={isXs}>
                        <Outlet />
                      </Navigation>
                    </P2GBox>
                    <Notifications />
                    <Tasks filterKey="" />
                    <Edit />
                    <WalkthroughPrompt tab={''} isXs={isXs} />
                    <SmartSendTasks />
                  </ConcernsContextProvider>
                </ProfileContextProvider>
              </SmartSendContextProvider>
            </DownloadContextProvider>
          </EventEmitterRC>
        </NavigationContextProvider>
      ) : (
        <P2GImageMessage
          image="/theme/smartsend/notifications/signing-in.png"
          contentKey="image-myaccount-signing-in"
          message="Signing you in"
          showLoader
        />
      )}
    </Suspense>
  );
}

Component.displayName = 'My Account';
